import { useQuery } from "react-query";

import { BillingsApi } from "@api/BillingsApi";

export const useBills = () => {
  return useQuery(["billing", "bills"], BillingsApi.fetchAllBills);
};
